"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Image = styled_components_1.default.img `
  display: block;
  max-width: 100%;
`;
function ImageDisplay(props) {
    let size = {};
    if (props.metadata) {
        const { width, height } = props.metadata;
        size = { width, height };
    }
    const mediaType = props.mediaType || props.mimetype;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Image, Object.assign({ alt: "", src: `data:${mediaType};base64,${props.data}` }, size))));
}
exports.default = ImageDisplay;
class PNGDisplay extends react_1.default.PureComponent {
    render() {
        return react_1.default.createElement(ImageDisplay, Object.assign({}, this.props));
    }
}
PNGDisplay.MIMETYPE = "image/png";
PNGDisplay.defaultProps = {
    data: "",
    mediaType: "image/png"
};
exports.PNGDisplay = PNGDisplay;
class JPEGDisplay extends react_1.default.PureComponent {
    render() {
        return react_1.default.createElement(ImageDisplay, Object.assign({}, this.props));
    }
}
JPEGDisplay.MIMETYPE = "image/jpeg";
JPEGDisplay.defaultProps = {
    data: "",
    mediaType: "image/jpeg"
};
exports.JPEGDisplay = JPEGDisplay;
class GIFDisplay extends react_1.default.PureComponent {
    render() {
        return react_1.default.createElement(ImageDisplay, Object.assign({}, this.props));
    }
}
GIFDisplay.MIMETYPE = "image/gif";
GIFDisplay.defaultProps = {
    data: "",
    mediaType: "image/gif"
};
exports.GIFDisplay = GIFDisplay;
